import * as commonScripts from '../common'
import { TimelineLite, CSSPlugin } from 'gsap/all'
import Choices from 'choices.js'
import 'whatwg-fetch'

// gsap.registerPlugin(CSSPlugin)
const plugins = [CSSPlugin]

const cmpRecentEpisodes = {
  component: null,
  apiEndpoint: null,
  filters: null,
  resultsDiv: null,
  loadMore: null,
  loadMoreBtn: null,
  choicesMenus: {},
  query: {},

  init: function (element) {
    const _ = this
    _.component = element
    _.apiEndpoint = element.getAttribute('data-api-endpoint')
    _.filters = element.querySelectorAll('select')
    _.resultsDiv = _.component.querySelector('#recentEpisodes')
    _.loadMoreBtn = _.component.querySelector('.btn-load-more')

    commonScripts.util.animationTranslate(this)
    commonScripts.util.inheritPermalink(element)

    _.filters.forEach((el) => {
      const id = el.getAttribute('id')
      _.choicesMenus[id] = new Choices(el, {
        itemSelectText: null,
        position: 'bottom',
        searchEnabled: false,
        shouldSort: false
      })

      el.addEventListener('change', (e) => {
        const ariaControls = el.getAttribute('aria-controls')
        if (ariaControls !== null) {
          const filterGroup = document.getElementById(ariaControls)
          if (filterGroup) {
            const controlledMenus = filterGroup.querySelectorAll('.choices')
            controlledMenus.forEach((menu) => {
              menu.classList.remove('visible')
              menu.querySelector('select').classList.remove('active')

              const target = menu.querySelector('select[data-group="' + el.value + '"]')
              if (target) {
                menu.classList.add('visible')
                target.classList.add('active')
              }
            })
          }
        }

        _.loadMore = false
        _.buildQuery()
      }, false)
    })

    if (_.loadMoreBtn != null) {
      _.loadMoreBtn.addEventListener('click', (e) => {
        e.preventDefault()
        _.loadMoreBtn.classList.add('disabled')
        const prevPage = _.loadMoreBtn.getAttribute('data-page') * 1
        _.loadMore = true
        _.buildQuery()
        _.loadMoreBtn.setAttribute('data-page', prevPage + 1)
      })
    }

    _.pageOnLoad()
  },

  pageOnLoad: function () {
    const _ = this
    if (window.location.search) {
      const searchParams = new URLSearchParams(window.location.search)
      searchParams.delete('page')
      const queryString = searchParams.toString()
      _.fetchResults(queryString)
      _.updateURL(queryString)
    } else {
      _.loadMoreBtn.classList.remove('disabled')
    }
  },

  buildQuery: function () {
    const _ = this
    let queryString
    _.query = {}

    // _.query.featuredId = _.component.getAttribute('data-featured-episode')
    _.query.featuredEpisodeId = _.component.getAttribute('data-featured-episode')
    _.query.lang = document.documentElement.lang
    if (_.loadMore) {
      const page = _.loadMoreBtn.getAttribute('data-page')
      _.query.page = page
    } else {
      if (_.loadMoreBtn != null) {
        _.loadMoreBtn.setAttribute('data-page', 1)
      }
      _.query.page = 0
    }

    this.query.lang = document.documentElement.lang

    // queryString = `featuredEpisodeId=${_.query.featuredId}&lang=${_.query.lang}&page=${_.query.page}`

    _.filters.forEach((el) => {	
      const id = el.getAttribute('name')	
      const active = el.classList.contains('active')	
      const tertiary = el.classList.contains('tertiary')	
      let exclude = !el.value	
      // exclude inactive tertiary menus from query string	
      if (tertiary && !active) {	
        exclude = true	
      }	
      // build/update query object	
      if (!exclude) {	
        _.query[id] = el.value	
      }	
      // convert to string for AJAX call	
      queryString = Object.keys(_.query).map((key) => {	
        return key + '=' + encodeURIComponent(_.query[key])	
      }).join('&')	
    })

    // queryString = `featuredEpisodeId=${_.query.featuredId}&lang=${_.query.lang}&page=${_.query.page}` + queryString

    _.updateURL(queryString)
    _.fetchResults(queryString)
  },

  fetchResults: function (queryString) {
    const _ = this
    const fetchOpts = {
      method: 'GET',
      headers: {}
    }

    let url = ''
    if (queryString.length > 0)
    {
      url = _.apiEndpoint + '?' + queryString
    } else {
      url = _.apiEndpoint
    }
    window.fetch(url, fetchOpts)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok')
        }
        return response.text()
      }).then((body) => {
        _.processResponse(body)
      }).catch((err) => {
        console.log('Request Failed', err)
      })
  },

  processResponse: function (body) {
    const _ = this
    const cards = _.resultsDiv.querySelectorAll('.cmp-viewpoint-cards__card')
    const stagingDiv = document.createElement('div')
    stagingDiv.classList.add('staging-zone')
    // stagingDiv.classList.add('row')
    stagingDiv.insertAdjacentHTML('beforeend', body)
    commonScripts.util.inheritPermalink(stagingDiv)

    if (_.loadMore) {
      _.resultsDiv.appendChild(stagingDiv)
      const newCards = _.resultsDiv.querySelectorAll('.cmp-viewpoint-cards__card')
      _.showCards(newCards)
      _.showHideMoreBtn()
    } else {
      const tl = new TimelineLite()
      tl.to(cards, { scale: 0.5, opacity: 0, duration: 0.5 })
      tl.eventCallback('onComplete', () => {
        _.resultsDiv.innerHTML = ''
        _.resultsDiv.appendChild(stagingDiv)
        const newCards = _.resultsDiv.querySelectorAll('.cmp-viewpoint-cards__card')
        _.showCards(newCards)
        _.showHideMoreBtn()
      })
    }

    _.loadMoreBtn.classList.remove('disabled')
    _.loadMoreBtn.blur()
  },

  showCards: function (cards) {
    if (cards) {
      const tl = new TimelineLite()
      tl.to(cards, { scale: 1, opacity: 1, duration: 0.5 })
    }
  },

  showHideMoreBtn: function () {
    const _ = this
    if (_.resultsDiv.querySelector('.no-results')) {
      _.loadMoreBtn.classList.add('d-none')
    } else {
      _.loadMoreBtn.classList.remove('d-none')
    }
  },

  updateURL: function (query) {
    const url = window.location.origin + window.location.pathname + '?' + query
    window.history.replaceState({}, document.title, url)
  }
}

export default cmpRecentEpisodes
